import * as api from 'services/api'

const askDetail = {
	state: {
		id: '',
		detail: {},
		related: [],
		comments: [],
		hasComments: false
	},
	mutations: {
		'ask:detail:update:id'(state, id) {
			state.id = id;
		},
		'ask:detail:update:detail'(state, detail = {}) {
			state.detail = detail;
		},
		'ask:detail:update:related'(state, related = []) {
			state.related = related;
		},
		'ask:detail:update:comments'(state, comments = []) {
			if(comments.length > 0) {
				state.hasComments = true;
			}
			state.comments = comments;
		}
	},
	actions: {
		async 'ask:detail:init'({commit, dispatch}, id) {
			// 保存id
			commit('ask:detail:update:id', id);
			// 获取详情
			dispatch('ask:detail:update:detail');
			// 获取热门评论
			dispatch('ask:detail:update:comments');
		},
		async 'ask:detail:update:detail'({commit, dispatch, state}) {
			const res = await api.getAskDetail({id: state.id});
			if(res.result.code === 0) {
				let data = res.data;
				commit('ask:detail:update:detail', data);
				// 获取相关问题
				dispatch('ask:detail:update:related', data.title);
			}
		},
		async 'ask:detail:update:related'({commit, state}, title) {
			const res = await api.getAskRelated({title});
			if(res.result.code === 0) {
				commit('ask:detail:update:related', res.data);
			}
		},
		async 'ask:detail:update:comments'({commit, state}) {
			const id = state.id + '_ask_' + state.id;
			const res = await api.getHotComments({articleid: id});
			if(res.result.code === 0) {
				let data = res.data;
				commit('ask:detail:update:comments', data.comments);
			}
		}
	},
	getters: {
		'ask:detail:detail': state => {
			return state.detail;
		},
		'ask:detail:related': state => {
			return state.related;
		},
		'ask:detail:comments': state => {
			return state.comments;
		},
		'ask:detail:hasComments': state => {
			return state.hasComments;
		}
	}
};

export default askDetail;


// WEBPACK FOOTER //
// ./src/store/modules/ask-detail.js